<template>
  <div>
    <Row class="expand-row" v-for="(good, index) in row" :key="index">
      <Col span="5" style="margin-left: 470px;">
        <span class="expand-value">{{(good.goodsDesc ? `${good.goodsName}-${good.goodsDesc}` : good.goodsName)}}</span>
      </Col>
      <Col span="1">
        <!-- <span class="expand-key">洗涤费: </span> -->
        <span class="expand-value">{{ good.price | initPrice }}</span>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
      row: Array
  },
  filters: {
    initPrice(val) {
      return (val/100).toFixed(2)
    }
  }
};
</script>

<style lang="scss" scoped>
.expand-row{
    margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/table-expand.vue